import { useVoiceRecorderStore } from "@/features/chat/model";
import { Modal, Button } from "react-bootstrap";

type ConfirmVoiceModalProps = {
  show: boolean;
  type: "recording" | "voiceBlob" | null;
  onClose: () => void;
  onConfirm?: () => void;
};

export const ConfirmVoiceModal = ({
  show,
  type,
  onClose,
  onConfirm,
}: ConfirmVoiceModalProps) => {
  if (!type) return null;

  const handleDelete = () => {
    const { cancelRecording, reset } = useVoiceRecorderStore.getState();
    cancelRecording();
    reset();

    onConfirm?.();
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Body>
        {type === "recording" && (
          <div>
            Вы точно хотите прекратить запись и удалить записанное голосовое
            сообщение?
          </div>
        )}
        {type === "voiceBlob" && <div>Удалить записанное сообщение?</div>}
      </Modal.Body>

      <Modal.Footer>
        <Button size="sm" variant="secondary" onClick={onClose}>
          Отмена
        </Button>
        <Button size="sm" variant="outline-secondary" onClick={handleDelete}>
          Удалить
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
